import { useState } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { Button, Input } from '../../components/Ui';
import { Reveal, Pop } from '../../components/Motion';
import CityPicker from '../../components/CityPicker';
import api from '../../api/endpoints';
import { TOKEN_KEY, storage } from '../../api/client';
import { useAuth } from '../../context/AuthContext';
import { colors } from '../../theme';

/** Collected right after the first successful OTP verification. */
const ProfileSetupPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { applyAuth } = useAuth();

  const { authPayload, role } = state || {};
  const [form, setForm] = useState({ name: '', email: '', city: '', district: '', state: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!authPayload) return <Navigate to="/get-started" replace />;

  const save = async (e) => {
    if (e) e.preventDefault();
    if (form.name.trim().length < 2) { setError('Please enter your name'); return; }
    setLoading(true);
    setError('');
    try {
      // The token from OTP verification must be stored before the profile call.
      storage.set(TOKEN_KEY, authPayload.token);
      const res = await api.user.update({
        name: form.name.trim(),
        email: form.email.trim(),
        city: form.city.trim(),
        district: form.district,
        state: form.state,
      });

      const payload = { ...authPayload, user: res.data };
      await applyAuth(payload, role);
      if (role === 'partner' && !authPayload.partner) {
        navigate('/partner/register', { replace: true });
        return;
      }
      navigate('/home', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff' }}>
      <div style={{ maxWidth: 460, width: '100%', margin: '0 auto', padding: 22 }}>
        <Pop>
          <div
            style={{
              width: 80, height: 80, borderRadius: 40, background: colors.primaryLight,
              display: 'grid', placeItems: 'center', fontSize: 36, marginTop: 26,
            }}
          >
            🎉
          </div>
        </Pop>

        <Reveal delay={90}>
          <h1 className="h1" style={{ marginTop: 20 }}>Welcome to KAAMWALA</h1>
          <p className="t-body" style={{ color: colors.muted, marginTop: 8, lineHeight: 1.55 }}>
            Tell us a little about you so partners know who they are serving.
          </p>
        </Reveal>

        <Reveal delay={170}>
          <form onSubmit={save} style={{ marginTop: 26 }}>
            <Input
              label="Full name"
              icon="👤"
              placeholder="e.g. Uggarsain Aggarwal"
              value={form.name}
              onChange={(e) => { setForm({ ...form, name: e.target.value }); setError(''); }}
              error={error}
            />
            <Input
              label="Email (optional)"
              icon="✉️"
              type="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <CityPicker
              label="City"
              value={form}
              onChange={({ city, district, state }) => setForm({ ...form, city, district, state })}
            />

            <Button
              title={role === 'partner' ? 'Continue to business details' : 'Start exploring'}
              type="submit"
              loading={loading}
              size="lg"
              full
            />
          </form>
        </Reveal>
      </div>
    </div>
  );
};

export default ProfileSetupPage;
